import { render, staticRenderFns } from "./Grid4.vue?vue&type=template&id=47030592&scoped=true"
import script from "./Grid4.vue?vue&type=script&lang=ts"
export * from "./Grid4.vue?vue&type=script&lang=ts"
import style0 from "./Grid4.vue?vue&type=style&index=0&id=47030592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47030592",
  null
  
)

export default component.exports